import { Typography } from "@mui/material";
import * as React from "react";

import {
  RobotoLinkHoverUnderline,
  RobotoTableCell,
  RobotoTableRow,
} from "@/shared/components";
import { UserLink } from "@/shared/components/UserLink";
import { CollectionRecord } from "@/shared/domain/collections";

import styles from "./CollectionRow.module.css";

interface CollectionRowProps {
  collection: CollectionRecord;
}

const tdStyle = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const CollectionRow: React.FC<CollectionRowProps> = ({ collection }) => {
  const numDatasets = collection.resources["dataset"]?.length || 0;
  const numFiles = collection.resources["file"]?.length || 0;

  return (
    <RobotoTableRow className={styles.tableRow}>
      <RobotoTableCell
        sx={{
          ...tdStyle,
        }}
        title={collection.name || collection.collection_id}
      >
        <RobotoLinkHoverUnderline
          to={`/collections/${collection.collection_id}`}
        >
          <Typography
            component={"abbr"}
            title={collection.name || collection.collection_id}
            sx={{
              cursor: "pointer",
              fontVariant: "none",
              textDecoration: "none",
            }}
            variant={"body2"}
          >
            {collection.name || collection.collection_id}
          </Typography>
        </RobotoLinkHoverUnderline>
      </RobotoTableCell>
      <RobotoTableCell
        sx={{
          ...tdStyle,
        }}
        title={collection.collection_id}
      >
        {collection.collection_id}
      </RobotoTableCell>
      <RobotoTableCell
        sx={{
          ...tdStyle,
        }}
      >
        {numDatasets + numFiles}
      </RobotoTableCell>
      <RobotoTableCell
        sx={{
          ...tdStyle,
        }}
        title={new Date(collection.created).toLocaleString()}
      >
        {new Date(collection.created).toLocaleString()}
      </RobotoTableCell>
      <RobotoTableCell
        sx={{
          ...tdStyle,
        }}
        title={collection.updated_by || undefined}
      >
        {collection.updated_by.includes("@") ? (
          <UserLink userId={collection.updated_by} />
        ) : (
          collection.updated_by
        )}
      </RobotoTableCell>
      <RobotoTableCell
        sx={{
          ...tdStyle,
        }}
        title={new Date(collection.updated).toLocaleString()}
      >
        {new Date(collection.updated).toLocaleString()}
      </RobotoTableCell>
      <RobotoTableCell
        sx={{
          ...tdStyle,
          maxWidth: 450,
        }}
      >
        {collection.description}
      </RobotoTableCell>
    </RobotoTableRow>
  );
};
